<template>
  <div id="Home">
    <BoxMenu/>
  </div>
</template>

<script>
import { app } from "../mixins/functions";
import { mapGetters } from "vuex";
import BoxMenu from './BoxMenu'

export default {
  name: "Home",
  mixins: [app],
  data() {
    return {
    };
  },
  components: {
    BoxMenu
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue